import { Slot } from '@radix-ui/react-slot';
import { cn } from '@ui/lib/utils';
import * as React from 'react';

interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * When true, the component will pass its children directly as the content
   * rather than wrapping them in a span element
   */
  asChild?: boolean;
}

const VisuallyHidden = React.forwardRef<HTMLSpanElement, VisuallyHiddenProps>(
  ({ className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'span';
    return (
      <Comp
        ref={ref}
        className={cn(
          'absolute h-px w-px overflow-hidden whitespace-nowrap p-0 border-0',
          'clip-rect-0',
          className
        )}
        style={{
          clip: 'rect(0 0 0 0)',
          clipPath: 'inset(50%)',
          margin: -1,
        }}
        {...props}
      />
    );
  }
);

VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
